import { SIDEBAR_TOGGLE } from './sidebar.types';

const toggleSidebar = ({ visible }) => ({
  type: SIDEBAR_TOGGLE,
  payload: { visible },
});

export { toggleSidebar };



// WEBPACK FOOTER //
// ./src/store/actions/sidebar.actions.js